import React from 'react'

const Spinner = () => (
  <div className="bg-blue spinner"></div>
)

export default Spinner



// WEBPACK FOOTER //
// ./src/components/Spinner.js